import IntegratedAppOptions from 'integrated-app-embedder/IntegratedAppOptions';
import { GoogleWorkspaceAppMessages } from './GoogleWorkspaceAppMessages';
export default class GoogleWorkspaceAppOptions extends IntegratedAppOptions {
  setAppStartRoute(route = '', queryParams = {}) {
    this.options.push({
      key: GoogleWorkspaceAppMessages.AppRoute,
      payload: {
        route,
        queryParams
      }
    });
    return this;
  }
  setDisplayMode(displayMode) {
    this.options.push({
      key: GoogleWorkspaceAppMessages.DisplayMode,
      payload: displayMode
    });
    return this;
  }
  setWindowHeight(height) {
    this.options.push({
      key: GoogleWorkspaceAppMessages.WindowHeight,
      payload: height
    });
    return this;
  }
  setRedirectUrl(redirectUrl) {
    this.options.push({
      key: GoogleWorkspaceAppMessages.RedirectUrl,
      payload: redirectUrl
    });
    return this;
  }
  setAppData(data) {
    this.options.push({
      key: GoogleWorkspaceAppMessages.AppData,
      payload: data
    });
    return this;
  }
}